const currencies = [
  {
    code: "EUR",
    name: "European Euro",
    decimals: 2,
  },
  {
    code: "INR",
    name: "Indian Rupee",
    decimals: 2,
  },
  {
    code: "JOD",
    name: "Jordanian Dinar",
    decimals: 3,
  },
  {
    code: "JPY",
    name: "Japanese Yen",
    decimals: 1,
  },
  {
    code: "KGS",
    name: "Kyrgyzstan Som",
    decimals: 2,
  },
  {
    code: "KZT",
    name: "Kazakstanian Tenge",
    decimals: 2,
  },
  {
    code: "TJS",
    name: "Tajikistani Somoni",
    decimals: 2,
  },
  {
    code: "USD",
    name: "United States Dollar",
    decimals: 2,
  },
];

export default currencies;
